import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "./ImprimirParcelasVariosContribuintes.scss"; // Crie um arquivo de estilo se necessário
import Swal from "sweetalert2";
import { Label } from "../Label/styles";
import InputComponent from "../../components/Input/input";
import Button from "../../components/Button/button";
import FichaFinanceiraService from "../../services/FichaFinanceiraService";
import {
  CreateFinancialRecordDto,
  UpdateStatusImpressaoDto,
} from "../../shared/dtos/FichaFinanceira.dto";
import { StatusImpressaoEnum } from "../../shared/enum/fichaFinanceira.enum";
import {
  BlueTitle,
  ContainerInput,
  ModalBody,
  ModalBodyContainer,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  TextError,
} from "../../shared/styles/global.styles";
import { IoCloseSharp } from "react-icons/io5";
import { Col, Row } from "react-bootstrap";
import { LocalPagamentoDto } from "../../shared/dtos/LocalPagamento.dto";
import { Lotacao } from "../../shared/interfaces/DadosFinanceirosInterface";
import lotacaoService from "../../services/LotacaoService";
import localPagamentoService from "../../services/LocalPagamentoService";
import SelectComponent from "../Select/select";
import contribuinteService from "../../services/ContribuinteService";
import { ContainerCount, LabelCount } from "./styles";
import { DatePickerInputContainer } from "../Input/styles";
import DatePicker from "react-datepicker";
import { GetRequestInProgressDto } from "../../shared/dtos/RequestInProgress.dto";
import requestInProgressService from "../../services/RequestInProgressService";
import { Colors } from "../../shared/colors/colors";
import { progressBarSwalAlert } from "../ProgressBarSwalAlert/ProgressBarSwalAlert";

// Define os tipos das props para o componente
interface ImprimirParcelasProps {
  onClose: () => void;
  show: boolean;
}

// Função para formatar valores monetários
// const formatCurrency = (value: string) => {
//   value = value.replace(/\D/g, ""); // Remove caracteres não numéricos
//   value = (parseFloat(value) / 100).toFixed(2).replace(".", ","); // Formata como valor monetário
//   return value.replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Adiciona separadores de milhar
// };

const ImprimirParcelasVariosContribuintes: React.FC<ImprimirParcelasProps> = ({
  onClose,
  show,
}) => {
  const hoje = new Date();
  const [locaisPagamento, setLocaisPagamento] = useState<LocalPagamentoDto[]>(
    []
  );
  const [lotacoes, setLotacoes] = useState<Lotacao[]>([]);
  const [isRequest, setIsRequest] = useState(false);
  const [selectLocalPagamento, setSelectLocalPagamento] =
    useState<LocalPagamentoDto>();
  const [selectLotacao, setSelectLotacao] = useState<Lotacao>();
  const [totalParcelas, setTotalParcelas] = useState<number>();
  const [dateRange, setDateRange] = useState<
    [Date | undefined, Date | undefined]
  >([undefined, undefined]);
  const [completedDateRange, setCompletedDateRange] = useState<boolean>(false);

  const fetchLocaisPagamento = async () => {
    try {
      const response =
        await localPagamentoService.getAllLocaisPagamentoWithLayoutRemessaRetorno();
      setLocaisPagamento(response);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro ao buscar locais de pagamento",
        allowOutsideClick: false,
      });
    }
  };

  const fetchLotacoes = async () => {
    try {
      const response = await lotacaoService.getAllLotacoes();
      setLotacoes(response);
    } catch (error) {
      Swal.fire({
        title: "Erro",
        text: "Erro ao buscar lotações. Por favor, tente novamente.",
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  };

  const handleSubmit = async () => {
    if (dateRange[0] && dateRange[1]) {
      if (dateRange[0] > dateRange[1]) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Data de início não pode ser maior que a data de fim",
          allowOutsideClick: false,
        });
        return;
      }
      const dateInicio = new Date(dateRange[0]!);
      const dateFim = new Date(dateRange[1]!);
      if (dateInicio.getTime() > dateFim.getTime()) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Data de início não pode ser maior que a data de fim",
          allowOutsideClick: false,
        });
        return;
      }
      setIsRequest(true);

      const result = await Swal.fire({
        icon: "question",
        title: "Confirmação",
        text: "Você realmente deseja imprimir as parcelas?",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        allowOutsideClick: false,
      });

      if (result.isConfirmed) {
        try {
          Swal.fire({
            icon: "info",
            title: "Aguarde",
            text: "Criando PDF de impressão de parcelas, por favor aguarde",
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          const randomString = Math.random().toString(36).substring(2, 10);
          const fileName = `boleto_parcelas_${randomString}.pdf`;

          const data = {
            dateInitial: dateRange[0]!,
            dateFinal: dateRange[1]!,
            fileName,
            idLocalPagamento: selectLocalPagamento?.id,
            idLotacao: selectLotacao?.id,
          };

          await FichaFinanceiraService.createBillOfPayLocalPagamentoAndLotacao(
            data
          ).then(async (responseCreateBillOfPay) => {
            if (responseCreateBillOfPay.success) {
              Swal.fire({
                title: "Processando solicitação",
                html: progressBarSwalAlert({
                  currentProgress: 0,
                  totalProgress: 0,
                  color: Colors.primary,
                  showProgressText: true,
                }),
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                },
              });

              let stopLoopCreateBillOfPay = false;
              let getRequestInProgressCreateBillOfPay =
                await requestInProgressService.getRequestInProgressById(
                  responseCreateBillOfPay.data.id
                );
              await new Promise((resolve) => setTimeout(resolve, 2000));

              while (!stopLoopCreateBillOfPay) {
                getRequestInProgressCreateBillOfPay =
                  await requestInProgressService.getRequestInProgressById(
                    responseCreateBillOfPay.data.id
                  );

                if (getRequestInProgressCreateBillOfPay.finished) {
                  stopLoopCreateBillOfPay = true;
                } else {
                  Swal.update({
                    html: progressBarSwalAlert({
                      currentProgress:
                        getRequestInProgressCreateBillOfPay.currentProgress,
                      totalProgress:
                        getRequestInProgressCreateBillOfPay.totalProgress,
                      color: Colors.primary,
                      showProgressText: true,
                    }),
                  });
                  await new Promise((resolve) => setTimeout(resolve, 2000));
                }
              }
              await requestInProgressService.deleteRequestInProgress(
                responseCreateBillOfPay.data.id
              );
              if (!getRequestInProgressCreateBillOfPay.error) {
                Swal.close();
                window.open(
                  `${process.env.REACT_APP_API_URL}pdfs/${fileName}`,
                  "_blank"
                );
                const firstResult = await Swal.fire({
                  title: "Sucesso!",
                  text: getRequestInProgressCreateBillOfPay.message,
                  icon: "success",
                  confirmButtonText: "OK",
                  allowOutsideClick: false,
                });
                if (firstResult.isConfirmed) {
                  const resultDeleteFile =
                    await FichaFinanceiraService.deleteFileInPdfs(fileName);
                  if (resultDeleteFile.success) {
                    const result = await Swal.fire({
                      title: "Sucesso!",
                      text: `Deseja trocar o status da impressão para ${StatusImpressaoEnum.IMPRESSO}?`,
                      icon: "info",
                      showCancelButton: true,
                      confirmButtonText: "Sim",
                      cancelButtonText: "Não",
                      allowOutsideClick: false,
                    });
                    if (result.isConfirmed) {
                      Swal.fire({
                        icon: "info",
                        title: "Aguarde",
                        text: "Efetuando atualização de status, por favor aguarde",
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                          Swal.showLoading();
                        },
                      });

                      const data = {
                        dateInitial: dateRange[0]!,
                        dateFinal: dateRange[1]!,
                        status: StatusImpressaoEnum.IMPRESSO,
                        idLocalPagamento: selectLocalPagamento?.id || undefined,
                        idLotacao: selectLotacao?.id || undefined,
                      };
                      await FichaFinanceiraService.updateStatusImpressaoByLocalPagamentoAndLotacao(
                        data
                      )
                        .then(async (responseStatusImpressao) => {
                          if (responseStatusImpressao.success) {
                            Swal.fire({
                              title: "Processando solicitação",
                              html: progressBarSwalAlert({
                                currentProgress: 0,
                                totalProgress: 0,
                                color: Colors.primary,
                                showProgressText: true,
                              }),
                              showConfirmButton: false,
                              allowOutsideClick: false,
                              didOpen: () => {
                                Swal.showLoading();
                              },
                            });

                            let stopLoopStatusImpressao = false;
                            let getRequestInProgressStatusImpressao =
                              await requestInProgressService.getRequestInProgressById(
                                responseStatusImpressao.data.id
                              );
                            await new Promise((resolve) =>
                              setTimeout(resolve, 2000)
                            );

                            while (!stopLoopStatusImpressao) {
                              getRequestInProgressStatusImpressao =
                                await requestInProgressService.getRequestInProgressById(
                                  responseStatusImpressao.data.id
                                );

                              if (
                                getRequestInProgressStatusImpressao.finished
                              ) {
                                stopLoopStatusImpressao = true;
                              } else {
                                Swal.update({
                                  html: progressBarSwalAlert({
                                    currentProgress:
                                      getRequestInProgressStatusImpressao.currentProgress,
                                    totalProgress:
                                      getRequestInProgressStatusImpressao.totalProgress,
                                    color: Colors.primary,
                                    showProgressText: true,
                                  }),
                                });
                                await new Promise((resolve) =>
                                  setTimeout(resolve, 2000)
                                );
                              }
                            }
                            await requestInProgressService.deleteRequestInProgress(
                              responseStatusImpressao.data.id
                            );
                            if (!getRequestInProgressStatusImpressao.error) {
                              Swal.fire({
                                title: "Sucesso!",
                                text: "Status dos boletos atualizados com sucesso!",
                                icon: "success",
                                confirmButtonText: "OK",
                                allowOutsideClick: false,
                              });
                              onClose();
                            } else {
                              Swal.fire({
                                title: "Erro",
                                text: getRequestInProgressStatusImpressao.message,
                                icon: "error",
                                confirmButtonText: "OK",
                                allowOutsideClick: false,
                              });
                            }
                          } else {
                            Swal.fire({
                              title: "Erro",
                              text: "Ocorreu um erro ao atualizar o status dos boletos",
                              icon: "error",
                              confirmButtonText: "OK",
                              allowOutsideClick: false,
                            });
                          }
                        })
                        .catch((error) => {
                          console.error(error);
                          Swal.fire({
                            icon: "error",
                            title: "Erro",
                            text:
                              error.message ||
                              "Ocorreu um erro ao processar sua solicitação",
                            allowOutsideClick: false,
                          });
                        });
                    }
                  }
                }
              } else {
                const resultDeleteFile =
                  await FichaFinanceiraService.deleteFileInPdfs(fileName);
                if (resultDeleteFile.success) {
                  Swal.fire({
                    title: "Erro",
                    text: getRequestInProgressCreateBillOfPay.message,
                    icon: "error",
                    confirmButtonText: "OK",
                    allowOutsideClick: false,
                  });
                }
              }
            } else {
              Swal.fire({
                title: "Erro",
                text: "Ocorreu um erro ao solicitar a impressão das parcelas. Por favor, tente novamente.",
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false,
              });
            }
          });
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Erro ao solicitar a impressão das parcelas",
            text: "Ocorreu um erro ao solicitar a impressão das parcelas. Por favor, tente novamente.",
            allowOutsideClick: false,
          });
          console.error("Erro ao solicitar a impressão das parcelas:", error);
        } finally {
          onClose();
          setIsRequest(false);
        }
      } else {
        setIsRequest(false);
      }
    } else {
      setIsRequest(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Data de vencimento não pode estar vazia",
        allowOutsideClick: false,
      });
    }
  };

  const countParcelasMensalidades = async () => {
    setIsRequest(true);
    if (dateRange[0] && dateRange[1]) {
      const data = {
        dateInitial: dateRange[0]!,
        dateFinal: dateRange[1]!,
        idLocalPagamento: selectLocalPagamento?.id
          ? selectLocalPagamento.id
          : undefined,
        idLotacao: selectLotacao ? selectLotacao.id : undefined,
      };
      await FichaFinanceiraService.countBillOfPayLocalPagamentoAndLotacao(data)
        .then((result) => {
          setTotalParcelas(result);
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            icon: "error",
            title: "Erro ao verificar total de fichas financeiras",
            text:
              error.message || "Ocorreu um erro ao processar sua solicitação",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
          setTotalParcelas(0);
        })
        .finally(() => {
          Swal.close();
          setIsRequest(false);
        });
    } else {
      setIsRequest(false);
    }
  };

  const handleDateRangeChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setDateRange([start ?? undefined, end ?? undefined]);

    if (start) {
      setDateRange([start, dateRange[1]]);
    }

    if (end) {
      setDateRange([dateRange[0], end]);
    }
    if (start && end) {
      if (start <= end) {
        setDateRange([start, end]);
      } else {
        setDateRange([end, start]);
      }
    }
  };

  const formatDateInput = (value: string): string => {
    // Remover caracteres não numéricos
    let numbers = value.replace(/\D/g, "");

    // Limitar a 8 dígitos (ddmmyyyy)
    numbers = numbers.substring(0, 8);

    // Aplicar máscara dd/mm/yyyy
    let formattedValue = "";
    if (numbers.length > 0) {
      formattedValue = numbers.substring(0, Math.min(2, numbers.length));

      if (numbers.length > 2) {
        formattedValue +=
          "/" + numbers.substring(2, Math.min(4, numbers.length));
      }

      if (numbers.length > 4) {
        formattedValue +=
          "/" + numbers.substring(4, Math.min(8, numbers.length));
      }
    }

    return formattedValue;
  };

  const handleDateInputChange = (e: any) => {
    if (!e || !e.target || typeof e.target.value !== "string") return;

    let value = e.target.value;

    // Não fazer nada se o campo estiver vazio
    if (!value) return;

    // Verificar se o valor contém hífen (separando intervalo de datas)
    const parts = value.split("-");

    if (parts.length > 1) {
      // Processar intervalo de datas (início - fim)
      let startDate = parts[0].trim();
      let endDate = parts[1].trim();

      // Formatar a primeira data
      startDate = formatDateInput(startDate);

      // Formatar a segunda data
      endDate = formatDateInput(endDate);

      // Recompor o valor com o formato correto
      e.target.value = `${startDate} - ${endDate}`;
      // if (
      //   parts.length === 2 &&
      //   parts[0].trim().length === 10 &&
      //   parts[1].trim().length === 10
      // ) {
      //   setCompletedDateRange(true);
      // } else {
      //   setCompletedDateRange(false);
      // }
    } else {
      // Processar uma única data
      const formattedDate = formatDateInput(value);

      // Verificar se a primeira data está completa (10 caracteres = dd/mm/aaaa)
      // Se estiver completa e não for uma operação de apagar (verificar se o valor atual é maior que o anterior)
      if (formattedDate.length === 10 && value.length >= formattedDate.length) {
        // Adicionar o hífen automaticamente
        e.target.value = `${formattedDate} - `;
      } else {
        e.target.value = formattedDate;
      }
    }
  };

  useEffect(() => {
    fetchLocaisPagamento();
    fetchLotacoes();
  }, []);

  useEffect(() => {
    countParcelasMensalidades();
  }, [selectLocalPagamento, selectLotacao, completedDateRange]);

  useEffect(() => {
    if (dateRange[0] && dateRange[1]) {
      countParcelasMensalidades();
    }
  }, [dateRange]);

  return (
    <ModalContainer show={show}>
      <ModalContent style={{ marginTop: "2%" }} width={40}>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => onClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>Imprimir parcelas para todos os contribuintes</BlueTitle>
        </ModalHeader>

        <ModalBody>
          <ContainerInput>
            <Label htmlFor="localPagamento">Local de Pagamento</Label>
            <SelectComponent
              color="black"
              placeholder="Todos locais de pagamento"
              isPlaceHolder={false}
              id="localPagamento"
              width={Number("100%")}
              name="localPagamento"
              disabled={isRequest}
              value={selectLocalPagamento?.id?.toString() ?? ""}
              onChange={(e) => {
                const selectedLocal = locaisPagamento.find(
                  (local) => local.id === parseInt(e.target.value)
                );
                setSelectLocalPagamento(selectedLocal);
              }}
              options={locaisPagamento.map((local) => ({
                value: local.id!.toString(),
                label: local.descricao,
              }))}
            />
          </ContainerInput>
          <ContainerInput>
            <Label htmlFor="lotacao">Lotação</Label>
            <SelectComponent
              color="black"
              placeholder="Todas"
              isPlaceHolder={false}
              id="lotacao"
              width={Number("100%")}
              name="lotacao"
              disabled={isRequest}
              value={selectLotacao?.id?.toString() ?? ""}
              onChange={(e) => {
                if (e.target.value === "0") {
                  setSelectLotacao({ id: 0, descricao: "Sem Lotacao" });
                } else {
                  const selectedLotacao = lotacoes.find(
                    (lotacao) => lotacao.id === parseInt(e.target.value)
                  );
                  setSelectLotacao(selectedLotacao);
                }
              }}
              options={[
                { value: "0", label: "Sem lotação" },
                ...lotacoes.map((lotacao) => ({
                  value: lotacao.id!.toString(),
                  label: lotacao.descricao,
                })),
              ]}
            />
          </ContainerInput>
          {/* <Row>
            <Col>
              <ContainerInput>
                <Label htmlFor="dataVencimento">Data Vencimento Início</Label>
                <InputComponent
                  type="date"
                  name="dataVencimentoInicio"
                  id="dataVencimentoInicio"
                  value={
                    dateRange[0] ? dateRange[0].toISOString().split("T")[0] : ""
                  }
                  onChange={(e) => {
                    const newDate = new Date(e.target.value);
                    if (isNaN(newDate.getTime())) {
                      setDateRange([undefined, dateRange[1]]);
                    } else {
                      setDateRange([newDate, dateRange[1]]);
                    }
                  }}
                  placeholder="00/00/0000"
                  color="#333"
                  width={Number("100%")}
                  border="1px solid #ccc"
                  disabled={isRequest}
                />
              </ContainerInput>
            </Col>
            <Col>
              <ContainerInput>
                <Label htmlFor="dataVencimento">Data Vencimento Fim</Label>
                <InputComponent
                  type="date"
                  name="dataVencimentoFim"
                  id="dataVencimentoFim"
                  value={
                    dateRange[1] ? dateRange[1].toISOString().split("T")[0] : ""
                  }
                  onChange={(e) => {
                    setDateRange([dateRange[0], new Date(e.target.value)]);
                  }}
                  placeholder="00/00/0000"
                  color="#333"
                  width={Number("100%")}
                  border="1px solid #ccc"
                  disabled={isRequest}
                />
              </ContainerInput>
            </Col>
          </Row> */}

          <Label className="filtro-label" htmlFor="dataVencimento">
            Data de vencimento
          </Label>
          <DatePickerInputContainer
            width={Number("100%")}
            hasIconLeft={false}
            hasIconRight={false}
            error={false}
            className={dateRange[0] || dateRange[1] ? "has-date-content" : ""}
          >
            <DatePicker
              selectsRange={true}
              startDate={dateRange[0] as Date | undefined}
              endDate={dateRange[1] as Date | undefined}
              onChange={(dates) =>
                handleDateRangeChange(dates as [Date | null, Date | null])
              }
              onChangeRaw={handleDateInputChange}
              calendarStartDay={0}
              className={`date-picker-input placeholder-custom ${
                dateRange[0] || dateRange[1] ? "has-value" : "no-value"
              }`}
              dateFormat="dd/MM/yyyy"
              placeholderText="00/00/0000 - 00/00/0000"
              showPopperArrow={false}
              popperPlacement="bottom-start"
              isClearable={false}
              showYearDropdown
              showMonthDropdown
              scrollableMonthYearDropdown
              wrapperClassName={
                dateRange[0] || dateRange[1]
                  ? "date-wrapper-filled"
                  : "date-wrapper-empty"
              }
              locale="pt-BR"
              autoComplete="off"
              allowSameDay
              onKeyDown={(e) => {
                // Permite números, barras, backspace e teclas de navegação
                if (
                  !/[0-9\/]/.test(e.key) &&
                  e.key !== "Backspace" &&
                  e.key !== "Delete" &&
                  e.key !== "ArrowLeft" &&
                  e.key !== "ArrowRight" &&
                  e.key !== "Tab"
                ) {
                  e.preventDefault();
                }

                // Adiciona barras automaticamente
                const input = e.currentTarget as HTMLInputElement;
                if (/[0-9]/.test(e.key)) {
                  const value = input.value;
                  if (value.length === 2 || value.length === 5) {
                    input.value = value + "/";
                  }
                }
              }}
            />
          </DatePickerInputContainer>
          {totalParcelas !== undefined ? (
            <ContainerCount>
              <Label fontSize={14}>{`A busca encontrou`}</Label>
              <LabelCount>{totalParcelas}</LabelCount>
              <Label fontSize={14}>{`parcelas.`}</Label>
            </ContainerCount>
          ) : null}
        </ModalBody>

        <ModalFooter>
          {/* <button type="submit" className="btn-submit">Cadastrar Parcelas</button> */}
          <Button
            schemaButton="full-primary"
            type="button"
            disabled={
              isRequest || totalParcelas === undefined || totalParcelas === 0
            }
            action={handleSubmit}
          >
            Imprimir Parcelas
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default ImprimirParcelasVariosContribuintes;
